import React from 'react';
import './Service.css';
import { VscServerProcess } from 'react-icons/vsc';
import { MdPhonelinkSetup } from 'react-icons/md';
import { FaServer } from 'react-icons/fa';

const Service = () => {
  return (
    <section id="service" className="mx-auto container">
      <div className="flex justify-center">
        <h2 className="text-white text-center  font-extrabold text-4xl relative z-20  ">
          PROVIDE SERVICES.
        </h2>
        <svg
          class="absolute mt-[20px]"
          width="175"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="pathItem"
            d="M5 20 Q 70 0 150 20"
            stroke="#E12457"
            fill="transparent"
            stroke-width="7"
            stroke-linecap="round"
          ></path>
        </svg>
      </div>

      <div className=" w-full mt-5 md:mt-16 grid grid-cols-1 gap-10 md:gap-5  md:grid-cols-3 md:px-12 px-4">
        <div className="card mt-12 md:mt-0">
          <div className="lines"></div>
          <div className="imgBx">
            <VscServerProcess size={120} className=" icon" />
          </div>
          <div className="content">
            <div className="details">
              <h2 className="mt-5">Software Development</h2>
              <p>
                I offer end-to-end software development services specializing in
                JavaScript (React), Golang.
              </p>
            </div>
          </div>
        </div>
        <div className="card mt-12 md:mt-0">
          <div className="lines"></div>
          <div className="imgBx">
            <MdPhonelinkSetup size={120} className=" icon" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Mobile App Development</h2>
              <p>
                I build fast, scalable create cross-platform mobile apps using
                React Native.
              </p>
            </div>
          </div>
        </div>

        <div className="card mt-12 md:mt-0">
          <div className="lines"></div>
          <div className="imgBx">
            <FaServer size={120} className=" icon" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Backend Development</h2>
              <p>
                I develop high-concurrency backend services and APIs known for
                their reliability using NodeJs and Golang.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
